module.exports = __webpack_public_path__ + "img/smart _logo@2x.551b9d78.png";